import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'index',
			component: () => import('@/views/index.vue')
		},
		{//文章资讯类的内容
			path: '/article',
			name: 'article',
			component: () => import('@/views/article.vue')
		},
		{//证书查询
			path: '/certificate/query',
			name: 'certificate_query',
			component: () => import('@/views/certificate_query.vue')
		},
		{//会员查询
			path: '/member/query',
			name: 'member_query',
			component: () => import('@/views/member_query.vue')
		},
		{//搜索结果页面
			path: '/search/result',
			name: 'search_result',
			component: () => import('@/views/search_result.vue')
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js